import React, { Component } from 'react'
import { Link } from 'react-router'
import Particles from 'react-particles-js'
import {
  Button,
  Container,
  Header,
  Segment,
  Grid,
  Image
} from 'semantic-ui-react'
 
class Index extends Component {

    render() {
        return(
            <div>
                <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                    <Container text>
                        <Header
                            as='h1'
                            content='Decentralized Autonomous City'
                            style={{
                                fontSize: '4em',
                                fontWeight: 'normal',
                                marginBottom: 0,
                                marginTop: '2em',
                            }}
													/>
                        <Header
                            as='h2'
                            content='The city of the future'
                            style={{
                                fontSize:'1.7em',
                                fontWeight: 'normal',
                                marginTop: '1.5em',
                            }}
													/>
                        <Button primary as={Link} to='/wallet' size='huge'>
													Get Wallet
                        </Button>
                    </Container>
                    <Particles style={{  position: 'absolute', top: '0', left: '0', zIndex: '-1'}}
                        params={{
                            particles: {
                                number: {
                                    value: 80,
                                    density: {
                                        enable: true,
                                        value_area: 800
                                    }
                                },
                                color: {
                                    value: "#000000"
                                },
                                shape: {
                                    type: "circle",
                                    stroke: {
                                        width: 0,
                                        color: "#000000"
                                    },
                                    polygon: {
                                        nb_sides: 5
                                    },
                                    image: {
                                        src: "img/github.svg",
                                        width: 100,
                                        height: 100
                                    }
                                },
                                opacity: {
                                    value: 0.5,
                                    random: true,
                                    anim: {
                                        enable: false,
                                        speed: 1,
                                        opacity_min: 0.1,
                                        sync: false
                                    }
                                },
                                size: {
                                    value: 4,
                                    random: true,
                                    anim: {
                                        enable: false,
                                        speed: 40,
                                        size_min: 0.1,
                                        sync: false
                                    }
                                },
                                line_linked: {
                                    enable: true,
                                    distance: 130,
                                    color: "#000000",
                                    opacity: 0.4,
                                    width: 1
                                },
                                move: {
                                    enable: true,
                                    speed: 3,
                                    direction: "none",
                                    random: true,
                                    straight: false,
                                    out_mode: "out",
                                    bounce: false,
                                    attract: {
                                        enable: false,
                                        rotateX: 600,
                                        rotateY: 1200
                                    }
                                }
                            },
                            interactivity: {
                                detect_on: "canvas",
                                events: {
                                    onhover: {
                                        enable: false,
                                        mode: "grab"
                                    },
                                    onclick: {
                                        enable: false,
                                        mode: "push"
                                    },
                                    resize: true
                                },
                                modes: {
                                    grab: {
                                        distance: 400,
                                        line_linked: {
                                            opacity: 1
                                        }
                                    },
                                    bubble: {
                                        distance: 400,
                                        size: 40,
                                        duration: 2,
                                        opacity: 8,
                                        speed: 3
                                    },
                                    repulse: {
                                        distance: 200,
                                        duration: 0.4
                                    },
                                    push: {
                                        particles_nb: 4
                                    },
                                    remove: {
                                        particles_nb: 2
                                    }
                                }
                            },
                            retina_detect: true
                        }}
/>
                </Segment>
                <Segment textAlign='center' inverted vertical style={{ padding: '4em 0em' }}>
                    <Header as='h1' inverted style={{ marginBottom: '2em' }} content='Autonomous city' />
                    <Container textAlign='left'>
                        <Grid stackable verticalAlign='middle'>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <Image centered  src='/logo.png'/>
                                </Grid.Column>
                                <Grid.Column width={12}>
                                    <Header  as='h3' inverted style={{ fontWeight: 'normal'}}
                                        content='Imagine a place where people decide their own destiny, without intermediaries, politicians, supervisors and advisers. Where there is no corruption, hypocrisy, manipulation and deception. Where the residents themselves determine where their money will go.'/>
                                    <Header  as='h3' inverted style={{ fontWeight: 'normal'}} 
                                        content='Every inhabitant of such a place has the opportunity to offer solutions to the pressing problem and, having won the support of the majority, to end it. Everyone has the right to vote, which can affect any decision.'/>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </Segment>
                <Segment textAlign='center' vertical style={{ padding: '4em 0em',  backgroundColor: '#fafafa' }}>
                    <Header as='h1' style={{ marginBottom: '2em' }} content='Vision (beta-version)' />
                    <Container textAlign='left'>
                        <Grid stackable divided>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Wallet'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='First of all you need an identifier that will be attached to you. Create a unique wallet and get some Ether to it.'/>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Citizen'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='Then you need to become a citizen of the city. Write your name and wait a minute until the transaction completes.'/>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Tax'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='To make any actions, the city needs a budget. The budget is filled with taxes of citizens. Therefore, in the test version, you have to pay some fee.'/>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Token'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='To take an active part in the life of the city (create proposals, vote, execute proposals) you need a token. You can buy only one token. Also you can return it in any moment.'/>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Proposal'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='You can create a proposal that will be visible to all citizens. In the proposal you can add the amount that will be used from the city budget (optional), enter recipient address (optional), specify the minimum number of votes and the time of voting.'/>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Voting'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='Then you can vote for the current proposal. Yes or No answers are now available.'/>
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Header as='h3' style={{ textTransform: 'uppercase'}} content='Executing'/>
                                    <Header as='h3' style={{ fontWeight: 'normal'}} 
                                        content='After the voting is over you can execute the proposal if it has gained more than the minimum number of votes or the amount of Ether does not exceed the budget of the city (if the amount is indicated).'/>
                                </Grid.Column>

                            </Grid.Row>
                        </Grid>
                    </Container>
                </Segment>
                <Segment textAlign='center' vertical style={{ padding: '4em 0em' }}>
                    <Container text>
                        <Header as='h3' style={{ marginBottom: '4em' }} content='This awesome stuff is used' />
                        <Grid relaxed columns={5}>
                            <Grid.Column>
                                <Image src='/assets/semantic-logo.png' as='a' href='https://react.semantic-ui.com/' target='_blank' size='tiny' />
                            </Grid.Column>
                            <Grid.Column>
                                <Image src='/assets/react-logo.png' as='a' href='https://reactjs.org/' target='_blank' size='tiny' />
                            </Grid.Column>
                            <Grid.Column>
                                <Image src='/assets/redux-logo.png' as='a' href='https://redux.js.org/' target='_blank' size='tiny' />
                            </Grid.Column>
                            <Grid.Column >
                                <Image src='/assets/truffle-logo.png' as='a' href='http://truffleframework.com/' target='_blank' size='tiny' />
                            </Grid.Column>
                            <Grid.Column >
                                <Image src='/assets/ethereum-logo.png' as='a' href='https://www.ethereum.org/' target='_blank' size='tiny' />
                            </Grid.Column>
                        </Grid>
                    </Container>
                </Segment>
            </div>
)
    }
}

export default Index



// WEBPACK FOOTER //
// ./src/layouts/Index.js